import $ from 'jquery';

export default function calcoloRata() {

  function floor(number) {
    return Math.floor(number*Math.pow(10,2))/Math.pow(10,2);
  }

  function init() {
    $(document).on('click', '#calcola-rata', function() {
      if (document.getElementById('capitale').value > 0 && document.getElementById('interesse').value > 0) {
        if (document.getElementById("m").checked) { var mensile = 12; }
        if (document.getElementById("t").checked) { var mensile = 4; }
        if (document.getElementById("s").checked) { var mensile = 2; }
        if (document.getElementById("a").checked) { var mensile = 1; }
        var mi = document.getElementById('interesse').value / (mensile * 100);
        var base = 1;
        var mbase = 1 + mi;
        var i = 0
        for (i=0; i < (document.getElementById("anno").value * mensile); i++) {
          base = base * mbase
        }
        document.getElementById('rata').value = floor(document.getElementById('capitale').value * mi / ( 1 - (1/base)))
      }
    });
  }
  
  $( document ).ready(function() {
    if($('#calcola-rata').length > 0) {
      init();
    }
  });  
}




























